<template>
  <div>
    <template v-if="transactions.length">
      <TransactionCard
        :transactionInfo="transaction"
        v-for="(transaction,index ) in transactions"
        :key="index"
      />
    </template>
    <p v-else>No transactions Available</p>
  </div>
</template>
<script>
import TransactionCard from "../components/TransactionCard/index";
export default {
  name: "TransactionHistory",
  components: { TransactionCard },
  data() {
    return {
      transactions: []
    };
  },
  mounted() {
    this.$store
      .dispatch("getCustomerRechargeHistory")
      .then(result => {
        this.transactions = result.data;
      })
      .catch(err => {});
  }
};
</script>



// WEBPACK FOOTER //
// src/components/TransactionHistory.vue